export const MetadataService = {
    get: (endpoint: string) => import("@/utils/misc").then(m => m.fetchOptionsMetadata(endpoint)),
    use: (endpoint: string) => import("@/utils/misc").then(m => m.useOptionsMetadata(endpoint)),
    clearCache: () => {
        Object.keys(localStorage)
            .filter(key => key.startsWith("options-metadata:"))
            .forEach(key => localStorage.removeItem(key));
    },
    preload: (objects: string[]) => Promise.all(objects.map(object => import("@/utils/misc").then(m => m.fetchOptionsMetadata(`/crm/objects/${object}/`))))
};
